import { render, staticRenderFns } from "./update-shipment-form.vue?vue&type=template&id=21736bcc&scoped=true"
import script from "./update-shipment-form.vue?vue&type=script&lang=js"
export * from "./update-shipment-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21736bcc",
  null
  
)

export default component.exports